import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddressMaintainanceService {

  constructor(private http: HttpClient) { }
  /**
   * get AssignmentDistrict Options by country
   */
  async getAssignmentDistrict(country: string, city: number): Promise<any>{
    const url = `${environment.logisticsApiUrl}/addressMaintain/assignmentDistrictOptions/${country}/${city}`;
    return await this.http.get(url).toPromise();
  }

  /**
   * get City Options by country
   */
   async getCityOptions(country: string): Promise<any>{
    const url = `${environment.logisticsApiUrl}/addressMaintain/cityOptions?country=${country}`;
    return await this.http.get(url).toPromise();
  }

  /**
   * get country
   * @returns country options
   */
  getCountryOptions(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/facility/countryOptions`;
    return this.http.get(url);
  }

  /**
   * get customer
   * @returns customer options
   */
   getCustomerOptions(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/Customer/Options`;
    return this.http.get(url);
  }

  /**
   * get address data
   * @returns address data
   */
   getAddressData(request: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/addressMaintain/addressData`;
    return this.http.post(url, request);
  }

  /**
   * save address data
   * @param saveAddressData
   */
  saveAddressData(saveAddressVal: any): Observable<any>{
    const url = `${environment.logisticsApiUrl}/addressMaintain/saveAddressData`;
    return this.http.post(url, saveAddressVal);
  }

  /**
   * get AssignmentDistrict All Options
   * @returns AssignmentDistrict All Options
   */
   getAssignmentDistrictAllOptions(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/addressMaintain/assignmentDistrictOptions`;
    return this.http.get(url);
  }

  getDetailAddressData(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/addressMaintain/getDetailAddress`;
    return this.http.post(url, request);
  }

  getImportAddressData(request: any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/addressMaintain/getImportAddressData`;
    return this.http.post(url, request);
  }

  doImportAddress(request: any) :Observable<any>{
    const url = `${environment.logisticsApiUrl}/addressMaintain/doImportAddress`;
    return this.http.post(url, request);
  }

  getAirPortOptions(citySeq: string):Promise<any>{
    const url = `${environment.logisticsApiUrl}/facility/airPortOptions/${citySeq}`;
    return this.http.get(url).toPromise();
  }

  getAirPortAllOptions():Observable<any>{
    const url = `${environment.logisticsApiUrl}/addressMaintain/getAirportAllOptions`;
    return this.http.get(url);
  }

  async getDOWithAddress(address: string): Promise<any>{
    const url = `${environment.logisticsApiUrl}/addressMaintain/getDOWithAddress`;
    return this.http.post(url, address).toPromise();
  }

  async doDPLCheck(request: any): Promise<any>{
    const url = `${environment.logisticsApiUrl}/addressDistionary/dplCheck`;
    return await this.http.post(url, request).toPromise();
  }

  async checkAddressIsAssociated(groupId: string): Promise<any> {
    const url = `${environment.logisticsApiUrl}/addressMaintain/checkAddressIsAssociated/${groupId}`;
    return await this.http.get(url).toPromise();
  }

  getStorerOptions(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/facility/erpStorerOptions`;
    return this.http.get(url);
  }

}
